module.exports = __webpack_public_path__ + "static/media/boy-5.2b26976b.svg";